import React from 'react';

import PropTypes from 'prop-types';

import { FadeInOutContainer, FadeInOut } from 'wanderu-animations';
import { localize } from 'wanderu-i18n';

import FilterEvents from '../../events';
import Station from '../Station/Station';
import Events from '../events/StationFilterEvents';

import styles from './StationsList.scss';

const STATIONS_TO_SHOW = 5;

class StationsList extends React.Component {
    static propTypes = {
        direction: PropTypes.string.isRequired,
        isFiltered: PropTypes.bool.isRequired,
        resetFilters: PropTypes.func.isRequired,
        setStationActive: PropTypes.func.isRequired,
        setStationOnlyActive: PropTypes.func.isRequired,
        stations: PropTypes.arrayOf(PropTypes.object).isRequired,
        t: PropTypes.func,
        title: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            showNum: STATIONS_TO_SHOW,
            stationsToShow: [],
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { stations } = props;
        const { showNum } = state;

        const stationsToShow = stations
            .sort((stationA, stationB) => {
                const stationStringAStartsWithLetter = /[a-z]/i.test(stationA.name[0]);
                const stationStringBStartsWithLetter = /[a-z]/i.test(stationB.name[0]);
                const stationStringA = stationA.name;
                const stationStringB = stationB.name;

                if (stationStringAStartsWithLetter === stationStringBStartsWithLetter) {
                    return stationStringA.localeCompare(stationStringB);
                }

                if (stationStringAStartsWithLetter) {
                    return -1;
                }

                return 1;
            })
            .slice(0, showNum);
        return {
            ...state,
            stationsToShow,
        };
    }

    toggleMoreButton = () => {
        const { stations } = this.props;
        const totalStations = stations.length;

        this.setState((oldState) => ({
            showNum:
                oldState.showNum === totalStations
                    ? STATIONS_TO_SHOW
                    : totalStations,
        }), () => this.triggerMoreButtonEvent());
    };

    triggerMoreButtonEvent = () => {
        const { direction } = this.props;
        const { showNum } = this.state;
        const action = STATIONS_TO_SHOW === showNum
            ? 'less'
            : 'more';
        Events.moreButtonClicked(action);

        const eventFunction = action === 'more'
            ? FilterEvents.filterListExpanded
            : FilterEvents.filterListCollapsed;

        eventFunction({
            filterType: `${direction}_stations`,
        });
    };

    resetFilters = () => {
        const {
            resetFilters,
            direction,
        } = this.props;
        resetFilters(direction);
    };

    render() {
        const {
            direction,
            isFiltered,
            setStationActive,
            setStationOnlyActive,
            stations,
            t,
            title,
        } = this.props;
        const {
            stationsToShow,
        } = this.state;
        const totalStations = stations.length;
        return (
            <div>
                <div className={styles.title}>{title}</div>
                <div className={styles.checkboxContainer}>
                    {stationsToShow.map((station) => {
                        return (
                            <Station
                                direction={direction}
                                key={station.id}
                                setStationActive={setStationActive}
                                setStationOnlyActive={setStationOnlyActive}
                                station={station}
                            />
                        );
                    })}
                    <div className={styles.resetButtonContainer}>
                        {totalStations > STATIONS_TO_SHOW && (
                            <span
                                className={styles.more}
                                onClick={this.toggleMoreButton}
                                role="button"
                            >
                                {totalStations > stationsToShow.length
                                    ? t('more')
                                    : t('less')}
                            </span>
                        )}
                        <FadeInOutContainer
                            animateHeight={false}
                            duration={250}
                        >
                            <FadeInOut show={isFiltered}>
                                <span
                                    className={styles.resetButton}
                                    onClick={this.resetFilters}
                                    role="button"
                                >
                                    {t('reset')}
                                </span>
                            </FadeInOut>
                        </FadeInOutContainer>
                    </div>
                </div>
            </div>
        );
    }
}

export { StationsList };
export default localize(StationsList, 'baseApp');
